// extracted by mini-css-extract-plugin
module.exports = {"btn":"SRSPrice_btn__1n8Xi"};